import React from "react";

const RatingStar = ({ className = "", fill = "#FFAD0D", clipId = "clip0_4828_6115" }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        className={className}
      >
        <g clipPath={`url(#${clipId})`}>
          <path
            d="M23.3631 8.58405L15.9851 7.45705L12.6781 0.413055C12.4311 -0.112945 11.5681 -0.112945 11.3211 0.413055L8.01515 7.45705L0.637149 8.58405C0.0311492 8.67705 -0.210851 9.41405 0.214149 9.84905L5.57415 15.3431L4.30715 23.1101C4.20615 23.7271 4.86515 24.1901 5.41015 23.8871L12.0001 20.2451L18.5901 23.8881C19.1301 24.1881 19.7951 23.7341 19.6931 23.1111L18.4261 15.3441L23.7861 9.85005C24.2111 9.41405 23.9681 8.67705 23.3631 8.58405Z"
            fill={fill}
          />
        </g>
        <defs>
          <clipPath id={clipId}>
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default RatingStar;
